import { SidePhotoContentCardDataProps } from '@ahc-digital/component-library';
import { C13SidePhotoContentCardProps } from './C13SidePhotoContentCard.types';
import { Image as JSSImage, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { parseDroplinkParam } from 'src/shared/shared.service';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox } from 'src/shared/param-utils';

export function GetSidePhotoContentCardModel({
  props,
}: {
  props?: C13SidePhotoContentCardProps;
  isEditing: boolean;
}): SidePhotoContentCardDataProps {
  const { renderRichText, renderLink } = useConditionalRendering();
  const { TitleType, Layout, ImageSide, SecondaryCtaStyle, ShouldLazyLoad } = props?.params || {};
  const {
    Image,
    Headline,
    SupportCopy,
    PrimaryCtaButton,
    SecondaryCtaButton,
    PrimaryLink,
    SecondaryLink,
  } = props?.fields || {};

  const titleTypeValue =
    (parseDroplinkParam(TitleType)?.value?.value as SidePhotoContentCardDataProps['headlineTag']) ||
    'p';

  const layoutValue =
    (parseDroplinkParam(Layout)?.value?.value as SidePhotoContentCardDataProps['layout']) ||
    'fifty';

  const imageSideValue =
    (parseDroplinkParam(ImageSide)?.value?.value as SidePhotoContentCardDataProps['imageSide']) ||
    'left';

  const secondaryCtaStyleValue =
    (parseDroplinkParam(SecondaryCtaStyle)?.value
      ?.value as SidePhotoContentCardDataProps['secondaryCtaStyle']) || 'link';

  const model: SidePhotoContentCardDataProps = {
    image: <JSSImage field={Image} />,
    imageSide: imageSideValue,
    headline: <Text field={Headline} />,
    headlineTag: titleTypeValue,
    supportCopy: renderRichText(SupportCopy),
    primaryCtaButton: renderLink(PrimaryCtaButton),
    secondaryCtaButton: renderLink(SecondaryCtaButton),
    secondaryCtaStyle: secondaryCtaStyleValue,
    primaryLink: renderLink(PrimaryLink),
    secondaryLink: renderLink(SecondaryLink),
    layout: layoutValue,
    shouldLazyLoad: getCheckbox(ShouldLazyLoad),
  };

  return model;
}
